const getQueryParam = (key, defaultValue = null) => {
  const params = new URLSearchParams(window.location.search)
  return params.get(key) || defaultValue
}

export default getQueryParam
